import React from "react"

import Style from "./style"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

const ConfirmModal = () => {

    const [label, , confirmEvent, cancelEvent] = useConfirmModalAtom()

    return (
        <DefaultModal closeEvent={cancelEvent} upper>
            <Style.Label>{label}</Style.Label>
            <Style.BtnDiv>
                <DefaultButton small clickEvent={confirmEvent}>확인</DefaultButton>
                <DefaultButton small clickEvent={cancelEvent} minor>취소</DefaultButton>
            </Style.BtnDiv>
        </DefaultModal>

    )
}

export default ConfirmModal
